import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT, heroGuarantees } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full overflow-hidden bg-navy px-5 pb-16 pt-10 text-white sm:pb-24 sm:pt-16" data-id="element-132" data-mp="4lyxkshw2qgt">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.1fr_1fr] lg:gap-14" data-id="element-133" data-mp="1297f6cerrfdj">
        <div className="text-center lg:text-left" data-id="element-134" data-mp="x9ur5oc5w29d">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.25,
          ease: EASE
        }} className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1.5 text-xs font-semibold text-ice" data-id="element-135" data-mp="xb5r1d2hkpv7">
            <span className="h-2 w-2 rounded-full bg-leaf" aria-hidden="true" data-id="element-136" data-mp="3d2tln1u126au" />
            Klasse 1–10 · Grundschule + Sekundarstufe I
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.04,
          ease: EASE
        }} className="mt-5 font-display text-[2.4rem] font-extrabold leading-[1.05] tracking-tight sm:text-6xl lg:text-[4rem]" data-id="element-137" data-mp="3j897lcz58bpj">
            Plane ein ganzes Jahr Mathematikunterricht in nur{' '}
            <span className="relative inline-block text-sun" data-id="element-138" data-mp="30hhpnn13bczj">5 Minuten</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.1,
          ease: EASE
        }} className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg lg:mx-0" data-id="element-139" data-mp="3599hs1zw9qrs">
            Schließe dich über 1.500 Lehrkräften an, die aufgehört haben zu improvisieren. Geh in
            jede Mathestunde mit allem, was du brauchst, um zu erklären, zu üben und deine Schüler
            wirklich weiterzubringen.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.16,
          ease: EASE
        }} className="mt-8 hidden lg:block" data-id="element-140" data-mp="s3ckw8bgjfpi">
            <CtaButton href="#offer" data-id="element-141" data-mp="dd5eiqyq5n56" />
            <GuaranteeList data-id="element-142" data-mp="de6n8os9pxjq" />
          </motion.div>
        </div>

        <motion.figure initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: EASE
      }} className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-143" data-mp="1b0nk5sx3a94y">
          <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} className="relative mx-auto w-[85%] drop-shadow-[0_30px_40px_rgba(0,0,0,0.45)]" data-id="element-144" data-mp="110wpnr8j3u4v" />
          <span className="absolute right-2 top-4 rotate-6 rounded-2xl bg-flame px-3 py-2 text-center font-display text-xs font-extrabold uppercase leading-tight text-white shadow-soft sm:right-6" data-id="element-145" data-mp="3lui86njf0tjs">
            + 5 Bonus-
            <br data-id="element-146" data-mp="1x786nshfdzw8" />
            Pakete
          </span>
          <figcaption className="relative mx-auto mt-4 max-w-sm text-center text-xs leading-relaxed text-white/60" data-id="element-147" data-mp="21by0zcwfr6f1">
            {PRODUCT_MOCKUP_ALT}
          </figcaption>
        </motion.figure>

        <div className="text-center lg:hidden" data-id="element-148" data-mp="2b0zi56epvtul">
          <CtaButton href="#offer" className="w-full sm:w-auto" data-id="element-149" data-mp="2b2sjq7ah3nvq" />
          <GuaranteeList data-id="element-150" data-mp="2fz0xphcxpb1b" />
        </div>
      </div>
    </section>;
}
function GuaranteeList() {
  return <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-semibold text-white/80 sm:text-sm lg:justify-start" data-id="element-151" data-mp="2kxc7js38bljj">
      {heroGuarantees.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-152" data-mp="2tyafumkpaf7x">
          <CheckIcon className="h-4 w-4 text-leaf" strokeWidth={3} aria-hidden="true" data-id="element-153" data-mp="umzhtubym26t" />
          {item}
        </li>)}
    </ul>;
}